import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "marketing-subscriber" }
const _hoisted_2 = { class: "marketing-subscriber__wrap" }
const _hoisted_3 = {
  key: 0,
  class: "marketing-subscriber__title"
}
const _hoisted_4 = {
  key: 2,
  class: "marketing-subscriber__form"
}
const _hoisted_5 = ["placeholder", "onKeyup"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 3,
  class: "marketing-subscriber__validation-error"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]

import { computed, ref } from 'vue';
  import { validateEmail } from '@/utils';

  import useContext from '@/composables/useContext';
  import useMarketingSubscriber from '@/composables/useMarketingSubscriber';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MarketingSubscriber',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  setup(__props) {

const props = __props

  const { replaceTokens } = useContext();
  const { requestPending, subscribe } = useMarketingSubscriber();

  

  const email = ref('');

  const validationError = ref('');
  const error = ref('');

  const formSubmitted = ref(false);

  const title = computed(() => {
    return props.block.fields.Title;
  });

  const subtitle = computed(() => {
    return props.block.fields.SubTitle;
  });

  const placeholder = computed(() => {
    return props.block.fields.Placeholder;
  });

  const consentMessage = computed(() => {
    return props.block.fields.MembershipConsentAgreement;
  });

  const buttonText = computed(() => {
    return props.block.fields.ButtonText;
  });

  const successfulSignupTitle = computed(() => {
    return props.block.fields.SuccessfulSignupTitle;
  });

  const invalidMailMessage = computed(() => {
    return props.block.fields.InvalidMailMessage;
  });

  const successfulSignupMessage = computed(() => {
    return replaceTokens(props.block.fields.SuccessfulSignupMessage || '', {
      email: email.value,
    });
  });

  const unsuccessfulSignupMessage = computed(() => {
    return props.block.fields.UnsuccessfulSignupMessage;
  });

  const resendFormMessage = computed(() => {
    return props.block.fields.ResendSignUpEmail;
  });

  function showForm() {
    formSubmitted.value = false;
  }

  function validateForm() {
    if (!email.value || !validateEmail(email.value.trim())) {
      validationError.value = invalidMailMessage.value;
      return false;
    }
    return true;
  }

  function clearValidationError() {
    validationError.value = '';
  }

  function clearError() {
    error.value = '';
  }

  async function submitForm() {
    try {
      clearError();

      if (!validateForm()) {
        return;
      }

      const args = {
        email: email.value.trim(),
      };

      const response = await subscribe(args);

      if (response.error !== 'NONE') {
        error.value = unsuccessfulSignupMessage.value;
        return;
      }

      formSubmitted.value = true;
    } catch (err) {
      error.value = unsuccessfulSignupMessage.value;
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(title))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(!formSubmitted.value ? _unref(title) : _unref(successfulSignupTitle)), 1))
        : _createCommentVNode("", true),
      (_unref(subtitle))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["marketing-subscriber__subtitle", { 'marketing-subscriber__subtitle--form-submitted': formSubmitted.value }])
          }, _toDisplayString(!formSubmitted.value ? _unref(subtitle) : _unref(successfulSignupMessage)), 3))
        : _createCommentVNode("", true),
      (!formSubmitted.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _unref(placeholder),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              autocomplete: "email",
              onFocus: clearValidationError,
              onBlur: validateForm,
              onKeyup: _withKeys(submitForm, ["enter"])
            }, null, 40, _hoisted_5), [
              [_vModelText, email.value]
            ]),
            _createElementVNode("button", {
              class: "secondary-button marketing-subscriber__button",
              disabled: _unref(requestPending),
              onClick: submitForm
            }, _toDisplayString(_unref(buttonText)), 9, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      (validationError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(validationError.value), 1))
        : _createCommentVNode("", true),
      (!error.value && !formSubmitted.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "marketing-subscriber__consent",
            innerHTML: _unref(consentMessage)
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true),
      (error.value && !formSubmitted.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: "marketing-subscriber__error",
            innerHTML: error.value
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true),
      (!error.value && formSubmitted.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 6,
            class: "marketing-subscriber__resend-message",
            onClick: showForm,
            innerHTML: _unref(resendFormMessage)
          }, null, 8, _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})